export const ALERTS_INFORMATION = '/api/notify/getAlertsInformation';
export const TEST_MODE_TRUE = {
  testMode: true,
};
